import { Component } from '@angular/core';
import { OrderStepBaseComponent } from '../../order-step-base-component';

@Component({
    selector: 'app-product-description',
    templateUrl: './product-description.component.html',
    styleUrls: ['./product-description.component.scss'],
    standalone: false,
})
export class ProductDescriptionComponent extends OrderStepBaseComponent<Record<string, never>> {
    public constructor() {
        super();
    }

    public getData(): Record<string, never> {
        return {};
    }
}
